<template>
  <div class="main-view">
    <b-container fluid class="py-4">
      <b-container>
        <div class="section-header mb-5">
          <h2 class="font-weight-bolder text-dark mb-2">Oportunidades</h2>
          <p class="text-muted lead">
            Encuentra las mejores oportunidades disponibles para ti
          </p>
        </div>
        <b-card class="content-card">
          <div id="widget"></div>
        </b-card>
      </b-container>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "opportunities",
  data() {
    return {
      projectId: null,
      showQuote: false,
      quoteWidget: null,
    };
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
  },
  mounted() {
    let self = this;
    setTimeout(function () {
      document.getElementById(
        "widget"
      ).innerHTML = `<mobysuite-opportunities customer="${self.customer}" version="${self.gcVersion}"><mobysuite-opportunities>`;
      let script = document.createElement("script");
      script.src = "https://cdn.mobysuite.com/opportunities/js/app.js";
      document.getElementById("widget").appendChild(script);
    }, 500);
  },
};
</script>

<style scoped>
.main-view {
  background-color: #f4f6f8;
  min-height: 100vh;
}

.section-header h2 {
  font-size: 2rem;
  letter-spacing: -0.5px;
}

.content-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
  padding: 1.5rem;
}
</style>
